import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { api } from '@/utils/api'

type Args = {
  linkId: string
  userId: string
}

export const useRemoveShare = () => {
  const queryClient = useQueryClient()

  return useMutation<
    { success: boolean },
    AxiosError<{ message: string }>,
    Args
  >({
    mutationFn: async ({ linkId, userId }) => {
      const { data } = await api.delete(`/links/${linkId}/share/${userId}`)
      return data.data
    },
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({
        queryKey: ['shared-with', args.linkId],
      })
    },
  })
}
